import { CommonModule } from '@angular/common';
import { NgxButtonComponent } from '@digipay/ngx-button';
import { NgxAppBarComponent } from '@digipay/ngx-app-bar';

import { RouteStateService } from '@client-monorepo/common/utilities';
import { HOME_ROUTE } from '../../../../data-access/constants/app-routes';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { WealthNavigationService } from '@client-monorepo/wealth/navigation';

@Component({
  selector: 'wealth-applet-campaign-start',
  standalone: true,
  imports: [CommonModule, NgxButtonComponent, NgxAppBarComponent],
  templateUrl: './campaign-capacity-full.component.html',
  styleUrl: './campaign-capacity-full.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CampaignCapacityFullComponent {
  state:
    | {
        type?: 'FixedIncome';
        symbol?: '';
        amount?: 0;
        unitCount?: 0;
        phoneNumber?: 0;
      }
    | undefined;
  navigationService = inject(WealthNavigationService);
  routeState = inject(RouteStateService);

  onBackHandler() {
    this.navigationService.navigate([HOME_ROUTE]);
  }
}
